 
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetRelationsDocument = gql`
    query GetRelations($isMessageOnly: Boolean) {
  relations {
    timezones {
      id
      name
    }
    countries {
      id
      name
      timezone {
        id
        name
      }
    }
    currencies {
      id
      code
      currency
      countries {
        id
      }
    }
    languages(isMessageOnly: $isMessageOnly) {
      id
      name
      isoCode
      isMessage
    }
  }
}
    `;

/**
 * __useGetRelationsQuery__
 *
 * To run a query within a React component, call `useGetRelationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelationsQuery({
 *   variables: {
 *      isMessageOnly: // value for 'isMessageOnly'
 *   },
 * });
 */
export function useGetRelationsQuery(baseOptions?: Apollo.QueryHookOptions<GetRelationsQuery, GetRelationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelationsQuery, GetRelationsQueryVariables>(GetRelationsDocument, options);
      }
export function useGetRelationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelationsQuery, GetRelationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelationsQuery, GetRelationsQueryVariables>(GetRelationsDocument, options);
        }
export function useGetRelationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRelationsQuery, GetRelationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRelationsQuery, GetRelationsQueryVariables>(GetRelationsDocument, options);
        }
export type GetRelationsQueryHookResult = ReturnType<typeof useGetRelationsQuery>;
export type GetRelationsLazyQueryHookResult = ReturnType<typeof useGetRelationsLazyQuery>;
export type GetRelationsSuspenseQueryHookResult = ReturnType<typeof useGetRelationsSuspenseQuery>;
export type GetRelationsQueryResult = Apollo.QueryResult<GetRelationsQuery, GetRelationsQueryVariables>;
export const GetCountryGeoForCompanyDocument = gql`
    query GetCountryGeoForCompany {
  countryGeo {
    country {
      id
      isoCode
      phoneCode {
        code
      }
      currencies {
        id
      }
      timezone {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCountryGeoForCompanyQuery__
 *
 * To run a query within a React component, call `useGetCountryGeoForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountryGeoForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountryGeoForCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountryGeoForCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetCountryGeoForCompanyQuery, GetCountryGeoForCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountryGeoForCompanyQuery, GetCountryGeoForCompanyQueryVariables>(GetCountryGeoForCompanyDocument, options);
      }
export function useGetCountryGeoForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountryGeoForCompanyQuery, GetCountryGeoForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountryGeoForCompanyQuery, GetCountryGeoForCompanyQueryVariables>(GetCountryGeoForCompanyDocument, options);
        }
export function useGetCountryGeoForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountryGeoForCompanyQuery, GetCountryGeoForCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountryGeoForCompanyQuery, GetCountryGeoForCompanyQueryVariables>(GetCountryGeoForCompanyDocument, options);
        }
export type GetCountryGeoForCompanyQueryHookResult = ReturnType<typeof useGetCountryGeoForCompanyQuery>;
export type GetCountryGeoForCompanyLazyQueryHookResult = ReturnType<typeof useGetCountryGeoForCompanyLazyQuery>;
export type GetCountryGeoForCompanySuspenseQueryHookResult = ReturnType<typeof useGetCountryGeoForCompanySuspenseQuery>;
export type GetCountryGeoForCompanyQueryResult = Apollo.QueryResult<GetCountryGeoForCompanyQuery, GetCountryGeoForCompanyQueryVariables>;
export const GetCountriesForCompanyDocument = gql`
    query GetCountriesForCompany {
  relations {
    countries {
      id
      name
      timezone {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCountriesForCompanyQuery__
 *
 * To run a query within a React component, call `useGetCountriesForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesForCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCountriesForCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesForCompanyQuery, GetCountriesForCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountriesForCompanyQuery, GetCountriesForCompanyQueryVariables>(GetCountriesForCompanyDocument, options);
      }
export function useGetCountriesForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesForCompanyQuery, GetCountriesForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountriesForCompanyQuery, GetCountriesForCompanyQueryVariables>(GetCountriesForCompanyDocument, options);
        }
export function useGetCountriesForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountriesForCompanyQuery, GetCountriesForCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountriesForCompanyQuery, GetCountriesForCompanyQueryVariables>(GetCountriesForCompanyDocument, options);
        }
export type GetCountriesForCompanyQueryHookResult = ReturnType<typeof useGetCountriesForCompanyQuery>;
export type GetCountriesForCompanyLazyQueryHookResult = ReturnType<typeof useGetCountriesForCompanyLazyQuery>;
export type GetCountriesForCompanySuspenseQueryHookResult = ReturnType<typeof useGetCountriesForCompanySuspenseQuery>;
export type GetCountriesForCompanyQueryResult = Apollo.QueryResult<GetCountriesForCompanyQuery, GetCountriesForCompanyQueryVariables>;
export const GetGmtForUpdateCompanyDocument = gql`
    query GetGMTForUpdateCompany($countryId: Int!) {
  relations {
    timezones(countryId: $countryId) {
      id
      name
    }
  }
}
    `;

/**
 * __useGetGmtForUpdateCompanyQuery__
 *
 * To run a query within a React component, call `useGetGmtForUpdateCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGmtForUpdateCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGmtForUpdateCompanyQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetGmtForUpdateCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetGmtForUpdateCompanyQuery, GetGmtForUpdateCompanyQueryVariables> & ({ variables: GetGmtForUpdateCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGmtForUpdateCompanyQuery, GetGmtForUpdateCompanyQueryVariables>(GetGmtForUpdateCompanyDocument, options);
      }
export function useGetGmtForUpdateCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGmtForUpdateCompanyQuery, GetGmtForUpdateCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGmtForUpdateCompanyQuery, GetGmtForUpdateCompanyQueryVariables>(GetGmtForUpdateCompanyDocument, options);
        }
export function useGetGmtForUpdateCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGmtForUpdateCompanyQuery, GetGmtForUpdateCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGmtForUpdateCompanyQuery, GetGmtForUpdateCompanyQueryVariables>(GetGmtForUpdateCompanyDocument, options);
        }
export type GetGmtForUpdateCompanyQueryHookResult = ReturnType<typeof useGetGmtForUpdateCompanyQuery>;
export type GetGmtForUpdateCompanyLazyQueryHookResult = ReturnType<typeof useGetGmtForUpdateCompanyLazyQuery>;
export type GetGmtForUpdateCompanySuspenseQueryHookResult = ReturnType<typeof useGetGmtForUpdateCompanySuspenseQuery>;
export type GetGmtForUpdateCompanyQueryResult = Apollo.QueryResult<GetGmtForUpdateCompanyQuery, GetGmtForUpdateCompanyQueryVariables>;
export const GetInfoCompanyDocument = gql`
    query GetInfoCompany($companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      name
      category {
        id
        name
        type
      }
      country {
        id
        name
        currencies {
          code
          currency
          id
        }
        timezone {
          id
          name
        }
      }
      city {
        id
        name
      }
      address
      phone
      image
      website
      currency {
        id
        code
        currency
      }
      timeZone {
        id
        name
      }
      deleted
      language {
        name
        id
        isoCode
      }
      languages {
        id
        isoCode
        name
      }
      messageLanguage {
        id
        name
        isoCode
      }
      primaryLanguage {
        id
        name
        isoCode
      }
    }
  }
}
    `;

/**
 * __useGetInfoCompanyQuery__
 *
 * To run a query within a React component, call `useGetInfoCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetInfoCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetInfoCompanyQuery, GetInfoCompanyQueryVariables> & ({ variables: GetInfoCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoCompanyQuery, GetInfoCompanyQueryVariables>(GetInfoCompanyDocument, options);
      }
export function useGetInfoCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoCompanyQuery, GetInfoCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoCompanyQuery, GetInfoCompanyQueryVariables>(GetInfoCompanyDocument, options);
        }
export function useGetInfoCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInfoCompanyQuery, GetInfoCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInfoCompanyQuery, GetInfoCompanyQueryVariables>(GetInfoCompanyDocument, options);
        }
export type GetInfoCompanyQueryHookResult = ReturnType<typeof useGetInfoCompanyQuery>;
export type GetInfoCompanyLazyQueryHookResult = ReturnType<typeof useGetInfoCompanyLazyQuery>;
export type GetInfoCompanySuspenseQueryHookResult = ReturnType<typeof useGetInfoCompanySuspenseQuery>;
export type GetInfoCompanyQueryResult = Apollo.QueryResult<GetInfoCompanyQuery, GetInfoCompanyQueryVariables>;
export const GetInfoCompanyForUpdateCompanyPageDocument = gql`
    query GetInfoCompanyForUpdateCompanyPage($companyId: Int!) {
  user(companyId: $companyId) {
    currentBranch {
      generalWorkSchedules {
        id
        type {
          id
          name
          slug
        }
        day {
          id
          name
          shortName
          number
        }
        period
      }
      kitchenWorkSchedules {
        id
        type {
          id
          name
          slug
        }
        day {
          id
          name
          shortName
          number
        }
        period
      }
    }
    company(id: $companyId) {
      id
      name
      country {
        id
        name
        currencies {
          id
          code
          currency
        }
        timezone {
          id
          name
        }
      }
      city {
        id
        name
      }
      address
      phone
      website
      timeZone {
        id
        name
      }
      messageLanguage {
        id
        name
      }
      currency {
        id
        currency
        code
      }
      category {
        type
      }
      languages {
        id
        name
        isoCode
      }
      primaryLanguage {
        id
        name
        isoCode
      }
      image
      deleted
    }
  }
}
    `;

/**
 * __useGetInfoCompanyForUpdateCompanyPageQuery__
 *
 * To run a query within a React component, call `useGetInfoCompanyForUpdateCompanyPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoCompanyForUpdateCompanyPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoCompanyForUpdateCompanyPageQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetInfoCompanyForUpdateCompanyPageQuery(baseOptions: Apollo.QueryHookOptions<GetInfoCompanyForUpdateCompanyPageQuery, GetInfoCompanyForUpdateCompanyPageQueryVariables> & ({ variables: GetInfoCompanyForUpdateCompanyPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoCompanyForUpdateCompanyPageQuery, GetInfoCompanyForUpdateCompanyPageQueryVariables>(GetInfoCompanyForUpdateCompanyPageDocument, options);
      }
export function useGetInfoCompanyForUpdateCompanyPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoCompanyForUpdateCompanyPageQuery, GetInfoCompanyForUpdateCompanyPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoCompanyForUpdateCompanyPageQuery, GetInfoCompanyForUpdateCompanyPageQueryVariables>(GetInfoCompanyForUpdateCompanyPageDocument, options);
        }
export function useGetInfoCompanyForUpdateCompanyPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInfoCompanyForUpdateCompanyPageQuery, GetInfoCompanyForUpdateCompanyPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInfoCompanyForUpdateCompanyPageQuery, GetInfoCompanyForUpdateCompanyPageQueryVariables>(GetInfoCompanyForUpdateCompanyPageDocument, options);
        }
export type GetInfoCompanyForUpdateCompanyPageQueryHookResult = ReturnType<typeof useGetInfoCompanyForUpdateCompanyPageQuery>;
export type GetInfoCompanyForUpdateCompanyPageLazyQueryHookResult = ReturnType<typeof useGetInfoCompanyForUpdateCompanyPageLazyQuery>;
export type GetInfoCompanyForUpdateCompanyPageSuspenseQueryHookResult = ReturnType<typeof useGetInfoCompanyForUpdateCompanyPageSuspenseQuery>;
export type GetInfoCompanyForUpdateCompanyPageQueryResult = Apollo.QueryResult<GetInfoCompanyForUpdateCompanyPageQuery, GetInfoCompanyForUpdateCompanyPageQueryVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($id: Int!, $input: CompanyInput!, $branchId: Int!) {
  updateCompany(id: $id, input: $input, branchId: $branchId) {
    id
    currency {
      currencySign
    }
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      branchId: // value for 'branchId'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const CreateNewCompanyDocument = gql`
    mutation CreateNewCompany($input: CompanyInput!) {
  createCompany(input: $input) {
    category {
      id
      name
    }
    name
    country {
      id
      name
    }
    branches {
      id
      name
      address
      timeZone
      currencyCode
      deleted
      onlineRegistration
      bookingQrLink
      removedOfTariff
      isAnyWorkScheduleForWorkingEmployees
      isAnyActiveServices
      isAnyActiveServiceEmployeeRelations
      country {
        id
        name
      }
    }
  }
}
    `;
export type CreateNewCompanyMutationFn = Apollo.MutationFunction<CreateNewCompanyMutation, CreateNewCompanyMutationVariables>;

/**
 * __useCreateNewCompanyMutation__
 *
 * To run a mutation, you first call `useCreateNewCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewCompanyMutation, { data, loading, error }] = useCreateNewCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNewCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewCompanyMutation, CreateNewCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewCompanyMutation, CreateNewCompanyMutationVariables>(CreateNewCompanyDocument, options);
      }
export type CreateNewCompanyMutationHookResult = ReturnType<typeof useCreateNewCompanyMutation>;
export type CreateNewCompanyMutationResult = Apollo.MutationResult<CreateNewCompanyMutation>;
export type CreateNewCompanyMutationOptions = Apollo.BaseMutationOptions<CreateNewCompanyMutation, CreateNewCompanyMutationVariables>;
export const GetGmtDocument = gql`
    query GetGMT {
  relations {
    timezones {
      id
      name
    }
  }
}
    `;

/**
 * __useGetGmtQuery__
 *
 * To run a query within a React component, call `useGetGmtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGmtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGmtQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGmtQuery(baseOptions?: Apollo.QueryHookOptions<GetGmtQuery, GetGmtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGmtQuery, GetGmtQueryVariables>(GetGmtDocument, options);
      }
export function useGetGmtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGmtQuery, GetGmtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGmtQuery, GetGmtQueryVariables>(GetGmtDocument, options);
        }
export function useGetGmtSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGmtQuery, GetGmtQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGmtQuery, GetGmtQueryVariables>(GetGmtDocument, options);
        }
export type GetGmtQueryHookResult = ReturnType<typeof useGetGmtQuery>;
export type GetGmtLazyQueryHookResult = ReturnType<typeof useGetGmtLazyQuery>;
export type GetGmtSuspenseQueryHookResult = ReturnType<typeof useGetGmtSuspenseQuery>;
export type GetGmtQueryResult = Apollo.QueryResult<GetGmtQuery, GetGmtQueryVariables>;
export const GetLanguagesDocument = gql`
    query GetLanguages($isMessageOnly: Boolean) {
  relations {
    languages(isMessageOnly: $isMessageOnly) {
      id
      name
      isoCode
      isMessage
    }
  }
}
    `;

/**
 * __useGetLanguagesQuery__
 *
 * To run a query within a React component, call `useGetLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesQuery({
 *   variables: {
 *      isMessageOnly: // value for 'isMessageOnly'
 *   },
 * });
 */
export function useGetLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
      }
export function useGetLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
export function useGetLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLanguagesQuery, GetLanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLanguagesQuery, GetLanguagesQueryVariables>(GetLanguagesDocument, options);
        }
export type GetLanguagesQueryHookResult = ReturnType<typeof useGetLanguagesQuery>;
export type GetLanguagesLazyQueryHookResult = ReturnType<typeof useGetLanguagesLazyQuery>;
export type GetLanguagesSuspenseQueryHookResult = ReturnType<typeof useGetLanguagesSuspenseQuery>;
export type GetLanguagesQueryResult = Apollo.QueryResult<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const GetLanguagesForLanguageVersionsDocument = gql`
    query GetLanguagesForLanguageVersions {
  relations {
    languages {
      id
      name
    }
  }
}
    `;

/**
 * __useGetLanguagesForLanguageVersionsQuery__
 *
 * To run a query within a React component, call `useGetLanguagesForLanguageVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguagesForLanguageVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguagesForLanguageVersionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLanguagesForLanguageVersionsQuery(baseOptions?: Apollo.QueryHookOptions<GetLanguagesForLanguageVersionsQuery, GetLanguagesForLanguageVersionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguagesForLanguageVersionsQuery, GetLanguagesForLanguageVersionsQueryVariables>(GetLanguagesForLanguageVersionsDocument, options);
      }
export function useGetLanguagesForLanguageVersionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguagesForLanguageVersionsQuery, GetLanguagesForLanguageVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguagesForLanguageVersionsQuery, GetLanguagesForLanguageVersionsQueryVariables>(GetLanguagesForLanguageVersionsDocument, options);
        }
export function useGetLanguagesForLanguageVersionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLanguagesForLanguageVersionsQuery, GetLanguagesForLanguageVersionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLanguagesForLanguageVersionsQuery, GetLanguagesForLanguageVersionsQueryVariables>(GetLanguagesForLanguageVersionsDocument, options);
        }
export type GetLanguagesForLanguageVersionsQueryHookResult = ReturnType<typeof useGetLanguagesForLanguageVersionsQuery>;
export type GetLanguagesForLanguageVersionsLazyQueryHookResult = ReturnType<typeof useGetLanguagesForLanguageVersionsLazyQuery>;
export type GetLanguagesForLanguageVersionsSuspenseQueryHookResult = ReturnType<typeof useGetLanguagesForLanguageVersionsSuspenseQuery>;
export type GetLanguagesForLanguageVersionsQueryResult = Apollo.QueryResult<GetLanguagesForLanguageVersionsQuery, GetLanguagesForLanguageVersionsQueryVariables>;
export const GetCurrenciesDocument = gql`
    query GetCurrencies {
  relations {
    currencies {
      id
      currency
      code
    }
  }
}
    `;

/**
 * __useGetCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrenciesQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
      }
export function useGetCurrenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
        }
export function useGetCurrenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrenciesQuery, GetCurrenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrenciesQuery, GetCurrenciesQueryVariables>(GetCurrenciesDocument, options);
        }
export type GetCurrenciesQueryHookResult = ReturnType<typeof useGetCurrenciesQuery>;
export type GetCurrenciesLazyQueryHookResult = ReturnType<typeof useGetCurrenciesLazyQuery>;
export type GetCurrenciesSuspenseQueryHookResult = ReturnType<typeof useGetCurrenciesSuspenseQuery>;
export type GetCurrenciesQueryResult = Apollo.QueryResult<GetCurrenciesQuery, GetCurrenciesQueryVariables>;
export const GetCompanyDocument = gql`
    query GetCompany($companyId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      id
      name
      country {
        id
        name
      }
      city {
        id
        name
      }
      address
      phone
      website
      timeZone {
        id
        name
      }
      languages {
        id
        name
      }
      currency {
        id
        currency
      }
      messageLanguage {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCompanyQuery__
 *
 * To run a query within a React component, call `useGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables> & ({ variables: GetCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
      }
export function useGetCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export function useGetCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyQuery, GetCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyQuery, GetCompanyQueryVariables>(GetCompanyDocument, options);
        }
export type GetCompanyQueryHookResult = ReturnType<typeof useGetCompanyQuery>;
export type GetCompanyLazyQueryHookResult = ReturnType<typeof useGetCompanyLazyQuery>;
export type GetCompanySuspenseQueryHookResult = ReturnType<typeof useGetCompanySuspenseQuery>;
export type GetCompanyQueryResult = Apollo.QueryResult<GetCompanyQuery, GetCompanyQueryVariables>;
export const GetBranchesIsDeletedDocument = gql`
    query GetBranchesIsDeleted($isDeleted: Boolean, $companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      branches(isDeleted: $isDeleted) {
        id
        deleted
        address
        bookingQrLink
        country {
          id
          name
        }
        onlineRegistration
        currencyCode
        name
        removedOfTariff
        timeZone
      }
    }
  }
}
    `;

/**
 * __useGetBranchesIsDeletedQuery__
 *
 * To run a query within a React component, call `useGetBranchesIsDeletedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBranchesIsDeletedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBranchesIsDeletedQuery({
 *   variables: {
 *      isDeleted: // value for 'isDeleted'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetBranchesIsDeletedQuery(baseOptions: Apollo.QueryHookOptions<GetBranchesIsDeletedQuery, GetBranchesIsDeletedQueryVariables> & ({ variables: GetBranchesIsDeletedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBranchesIsDeletedQuery, GetBranchesIsDeletedQueryVariables>(GetBranchesIsDeletedDocument, options);
      }
export function useGetBranchesIsDeletedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBranchesIsDeletedQuery, GetBranchesIsDeletedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBranchesIsDeletedQuery, GetBranchesIsDeletedQueryVariables>(GetBranchesIsDeletedDocument, options);
        }
export function useGetBranchesIsDeletedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBranchesIsDeletedQuery, GetBranchesIsDeletedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBranchesIsDeletedQuery, GetBranchesIsDeletedQueryVariables>(GetBranchesIsDeletedDocument, options);
        }
export type GetBranchesIsDeletedQueryHookResult = ReturnType<typeof useGetBranchesIsDeletedQuery>;
export type GetBranchesIsDeletedLazyQueryHookResult = ReturnType<typeof useGetBranchesIsDeletedLazyQuery>;
export type GetBranchesIsDeletedSuspenseQueryHookResult = ReturnType<typeof useGetBranchesIsDeletedSuspenseQuery>;
export type GetBranchesIsDeletedQueryResult = Apollo.QueryResult<GetBranchesIsDeletedQuery, GetBranchesIsDeletedQueryVariables>;
export const GetRoleUserDocument = gql`
    query GetRoleUser($companyId: Int!) {
  user(companyId: $companyId) {
    id
    email
    role(companyId: $companyId) {
      id
      name
    }
    currentBranch {
      id
    }
    company(id: $companyId) {
      id
    }
  }
}
    `;

/**
 * __useGetRoleUserQuery__
 *
 * To run a query within a React component, call `useGetRoleUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleUserQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetRoleUserQuery(baseOptions: Apollo.QueryHookOptions<GetRoleUserQuery, GetRoleUserQueryVariables> & ({ variables: GetRoleUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleUserQuery, GetRoleUserQueryVariables>(GetRoleUserDocument, options);
      }
export function useGetRoleUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleUserQuery, GetRoleUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleUserQuery, GetRoleUserQueryVariables>(GetRoleUserDocument, options);
        }
export function useGetRoleUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRoleUserQuery, GetRoleUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRoleUserQuery, GetRoleUserQueryVariables>(GetRoleUserDocument, options);
        }
export type GetRoleUserQueryHookResult = ReturnType<typeof useGetRoleUserQuery>;
export type GetRoleUserLazyQueryHookResult = ReturnType<typeof useGetRoleUserLazyQuery>;
export type GetRoleUserSuspenseQueryHookResult = ReturnType<typeof useGetRoleUserSuspenseQuery>;
export type GetRoleUserQueryResult = Apollo.QueryResult<GetRoleUserQuery, GetRoleUserQueryVariables>;
export const GetCompanyModulesDocument = gql`
    query GetCompanyModules($companyId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      modules {
        id
        name
        active(companyId: $companyId)
        childModules {
          id
          name
          active(companyId: $companyId)
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanyModulesQuery__
 *
 * To run a query within a React component, call `useGetCompanyModulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyModulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyModulesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyModulesQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyModulesQuery, GetCompanyModulesQueryVariables> & ({ variables: GetCompanyModulesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyModulesQuery, GetCompanyModulesQueryVariables>(GetCompanyModulesDocument, options);
      }
export function useGetCompanyModulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyModulesQuery, GetCompanyModulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyModulesQuery, GetCompanyModulesQueryVariables>(GetCompanyModulesDocument, options);
        }
export function useGetCompanyModulesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyModulesQuery, GetCompanyModulesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyModulesQuery, GetCompanyModulesQueryVariables>(GetCompanyModulesDocument, options);
        }
export type GetCompanyModulesQueryHookResult = ReturnType<typeof useGetCompanyModulesQuery>;
export type GetCompanyModulesLazyQueryHookResult = ReturnType<typeof useGetCompanyModulesLazyQuery>;
export type GetCompanyModulesSuspenseQueryHookResult = ReturnType<typeof useGetCompanyModulesSuspenseQuery>;
export type GetCompanyModulesQueryResult = Apollo.QueryResult<GetCompanyModulesQuery, GetCompanyModulesQueryVariables>;
export const GetCompanyModulesForCreateOwnerDocument = gql`
    query GetCompanyModulesForCreateOwner($companyId: Int!) {
  user {
    company(id: $companyId) {
      modules {
        id
        name
        active(companyId: $companyId)
        childModules {
          id
          name
          active(companyId: $companyId)
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanyModulesForCreateOwnerQuery__
 *
 * To run a query within a React component, call `useGetCompanyModulesForCreateOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyModulesForCreateOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyModulesForCreateOwnerQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyModulesForCreateOwnerQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyModulesForCreateOwnerQuery, GetCompanyModulesForCreateOwnerQueryVariables> & ({ variables: GetCompanyModulesForCreateOwnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyModulesForCreateOwnerQuery, GetCompanyModulesForCreateOwnerQueryVariables>(GetCompanyModulesForCreateOwnerDocument, options);
      }
export function useGetCompanyModulesForCreateOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyModulesForCreateOwnerQuery, GetCompanyModulesForCreateOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyModulesForCreateOwnerQuery, GetCompanyModulesForCreateOwnerQueryVariables>(GetCompanyModulesForCreateOwnerDocument, options);
        }
export function useGetCompanyModulesForCreateOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyModulesForCreateOwnerQuery, GetCompanyModulesForCreateOwnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyModulesForCreateOwnerQuery, GetCompanyModulesForCreateOwnerQueryVariables>(GetCompanyModulesForCreateOwnerDocument, options);
        }
export type GetCompanyModulesForCreateOwnerQueryHookResult = ReturnType<typeof useGetCompanyModulesForCreateOwnerQuery>;
export type GetCompanyModulesForCreateOwnerLazyQueryHookResult = ReturnType<typeof useGetCompanyModulesForCreateOwnerLazyQuery>;
export type GetCompanyModulesForCreateOwnerSuspenseQueryHookResult = ReturnType<typeof useGetCompanyModulesForCreateOwnerSuspenseQuery>;
export type GetCompanyModulesForCreateOwnerQueryResult = Apollo.QueryResult<GetCompanyModulesForCreateOwnerQuery, GetCompanyModulesForCreateOwnerQueryVariables>;
export const GetActiveCompaniesDocument = gql`
    query GetActiveCompanies($companyId: Int!) {
  user(companyId: $companyId) {
    companies {
      id
      name
      loggedInUser {
        id
        name
        surname
        role {
          name
        }
        position {
          name
        }
      }
    }
    company(id: $companyId) {
      id
      name
      isPremiumOn
      deleted
      image
    }
  }
}
    `;

/**
 * __useGetActiveCompaniesQuery__
 *
 * To run a query within a React component, call `useGetActiveCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveCompaniesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetActiveCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetActiveCompaniesQuery, GetActiveCompaniesQueryVariables> & ({ variables: GetActiveCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveCompaniesQuery, GetActiveCompaniesQueryVariables>(GetActiveCompaniesDocument, options);
      }
export function useGetActiveCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveCompaniesQuery, GetActiveCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveCompaniesQuery, GetActiveCompaniesQueryVariables>(GetActiveCompaniesDocument, options);
        }
export function useGetActiveCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActiveCompaniesQuery, GetActiveCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActiveCompaniesQuery, GetActiveCompaniesQueryVariables>(GetActiveCompaniesDocument, options);
        }
export type GetActiveCompaniesQueryHookResult = ReturnType<typeof useGetActiveCompaniesQuery>;
export type GetActiveCompaniesLazyQueryHookResult = ReturnType<typeof useGetActiveCompaniesLazyQuery>;
export type GetActiveCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetActiveCompaniesSuspenseQuery>;
export type GetActiveCompaniesQueryResult = Apollo.QueryResult<GetActiveCompaniesQuery, GetActiveCompaniesQueryVariables>;
export const GetCompanyAndRoleDocument = gql`
    query getCompanyAndRole($companyId: Int!, $isOnlyParents: Boolean, $branchId: Int!, $page: Int, $itemsPerPage: Int) {
  user(companyId: $companyId) {
    id
    roles
    company(id: $companyId) {
      id
      name
      phone
      isPremiumOn
      bookingQrLink
      address
      deleted
      image
      paidFeatures {
        id
        name
        dateOfEnd
        price
        dateOfLastPayment
        isYearly
      }
      modules(isOnlyParents: $isOnlyParents) {
        id
        name
        active(companyId: $companyId)
        isPaymentRequired
        isPaid(companyId: $companyId)
        isFreeAccess
      }
    }
    role(companyId: $companyId) {
      id
      name
      isOwner
    }
    employee(companyId: $companyId) {
      id
      name
      surname
      image
      userBranchRelations(id: $branchId) {
        id
        branch {
          id
        }
        role {
          id
          name
        }
      }
    }
  }
  role(branchId: $branchId, page: $page, itemsPerPage: $itemsPerPage) {
    roles {
      companyAccesses {
        role {
          name
          id
          isOwner
        }
        action
        id
      }
      id
      name
      isOwner
    }
  }
}
    `;

/**
 * __useGetCompanyAndRoleQuery__
 *
 * To run a query within a React component, call `useGetCompanyAndRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyAndRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyAndRoleQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      isOnlyParents: // value for 'isOnlyParents'
 *      branchId: // value for 'branchId'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *   },
 * });
 */
export function useGetCompanyAndRoleQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyAndRoleQuery, GetCompanyAndRoleQueryVariables> & ({ variables: GetCompanyAndRoleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyAndRoleQuery, GetCompanyAndRoleQueryVariables>(GetCompanyAndRoleDocument, options);
      }
export function useGetCompanyAndRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyAndRoleQuery, GetCompanyAndRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyAndRoleQuery, GetCompanyAndRoleQueryVariables>(GetCompanyAndRoleDocument, options);
        }
export function useGetCompanyAndRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyAndRoleQuery, GetCompanyAndRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyAndRoleQuery, GetCompanyAndRoleQueryVariables>(GetCompanyAndRoleDocument, options);
        }
export type GetCompanyAndRoleQueryHookResult = ReturnType<typeof useGetCompanyAndRoleQuery>;
export type GetCompanyAndRoleLazyQueryHookResult = ReturnType<typeof useGetCompanyAndRoleLazyQuery>;
export type GetCompanyAndRoleSuspenseQueryHookResult = ReturnType<typeof useGetCompanyAndRoleSuspenseQuery>;
export type GetCompanyAndRoleQueryResult = Apollo.QueryResult<GetCompanyAndRoleQuery, GetCompanyAndRoleQueryVariables>;
export const GetCompanyAndRoleWithoutOwnerDocument = gql`
    query GetCompanyAndRoleWithoutOwner($companyId: Int!, $isOnlyParents: Boolean, $branchId: Int!, $page: Int, $itemsPerPage: Int) {
  user {
    id
    roles
    company(id: $companyId) {
      id
      name
      phone
      isPremiumOn
      bookingQrLink
      address
      deleted
      image
      paidFeatures {
        id
        name
        dateOfEnd
        price
        dateOfLastPayment
        isYearly
      }
      modules(isOnlyParents: $isOnlyParents) {
        id
        name
        active(companyId: $companyId)
        isPaymentRequired
        isPaid(companyId: $companyId)
        isFreeAccess
      }
    }
    role(companyId: $companyId) {
      id
      name
      isOwner
    }
    employee(companyId: $companyId) {
      id
      name
      surname
      image
      userBranchRelations(id: $branchId) {
        id
        branch {
          id
        }
        role {
          id
          name
        }
      }
    }
  }
  role(branchId: $branchId, page: $page, itemsPerPage: $itemsPerPage) {
    roles {
      companyAccesses {
        role {
          name
          id
          isOwner
        }
        action
        id
      }
      id
      name
      isOwner
    }
  }
}
    `;

/**
 * __useGetCompanyAndRoleWithoutOwnerQuery__
 *
 * To run a query within a React component, call `useGetCompanyAndRoleWithoutOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyAndRoleWithoutOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyAndRoleWithoutOwnerQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      isOnlyParents: // value for 'isOnlyParents'
 *      branchId: // value for 'branchId'
 *      page: // value for 'page'
 *      itemsPerPage: // value for 'itemsPerPage'
 *   },
 * });
 */
export function useGetCompanyAndRoleWithoutOwnerQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyAndRoleWithoutOwnerQuery, GetCompanyAndRoleWithoutOwnerQueryVariables> & ({ variables: GetCompanyAndRoleWithoutOwnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyAndRoleWithoutOwnerQuery, GetCompanyAndRoleWithoutOwnerQueryVariables>(GetCompanyAndRoleWithoutOwnerDocument, options);
      }
export function useGetCompanyAndRoleWithoutOwnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyAndRoleWithoutOwnerQuery, GetCompanyAndRoleWithoutOwnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyAndRoleWithoutOwnerQuery, GetCompanyAndRoleWithoutOwnerQueryVariables>(GetCompanyAndRoleWithoutOwnerDocument, options);
        }
export function useGetCompanyAndRoleWithoutOwnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyAndRoleWithoutOwnerQuery, GetCompanyAndRoleWithoutOwnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyAndRoleWithoutOwnerQuery, GetCompanyAndRoleWithoutOwnerQueryVariables>(GetCompanyAndRoleWithoutOwnerDocument, options);
        }
export type GetCompanyAndRoleWithoutOwnerQueryHookResult = ReturnType<typeof useGetCompanyAndRoleWithoutOwnerQuery>;
export type GetCompanyAndRoleWithoutOwnerLazyQueryHookResult = ReturnType<typeof useGetCompanyAndRoleWithoutOwnerLazyQuery>;
export type GetCompanyAndRoleWithoutOwnerSuspenseQueryHookResult = ReturnType<typeof useGetCompanyAndRoleWithoutOwnerSuspenseQuery>;
export type GetCompanyAndRoleWithoutOwnerQueryResult = Apollo.QueryResult<GetCompanyAndRoleWithoutOwnerQuery, GetCompanyAndRoleWithoutOwnerQueryVariables>;
export const GetLoginCompaniesDocument = gql`
    query getLoginCompanies($email: String!) {
  loginCompanies(email: $email) {
    id
    name
    employee {
      id
      name
      surname
      role
    }
    isBlocked
  }
}
    `;

/**
 * __useGetLoginCompaniesQuery__
 *
 * To run a query within a React component, call `useGetLoginCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoginCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoginCompaniesQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetLoginCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetLoginCompaniesQuery, GetLoginCompaniesQueryVariables> & ({ variables: GetLoginCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoginCompaniesQuery, GetLoginCompaniesQueryVariables>(GetLoginCompaniesDocument, options);
      }
export function useGetLoginCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoginCompaniesQuery, GetLoginCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoginCompaniesQuery, GetLoginCompaniesQueryVariables>(GetLoginCompaniesDocument, options);
        }
export function useGetLoginCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLoginCompaniesQuery, GetLoginCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLoginCompaniesQuery, GetLoginCompaniesQueryVariables>(GetLoginCompaniesDocument, options);
        }
export type GetLoginCompaniesQueryHookResult = ReturnType<typeof useGetLoginCompaniesQuery>;
export type GetLoginCompaniesLazyQueryHookResult = ReturnType<typeof useGetLoginCompaniesLazyQuery>;
export type GetLoginCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetLoginCompaniesSuspenseQuery>;
export type GetLoginCompaniesQueryResult = Apollo.QueryResult<GetLoginCompaniesQuery, GetLoginCompaniesQueryVariables>;
export const GetLanguageVersionsForCompanyDocument = gql`
    query GetLanguageVersionsForCompany($companyId: Int!) {
  user {
    company(id: $companyId) {
      languages {
        id
        name
      }
      primaryLanguage {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetLanguageVersionsForCompanyQuery__
 *
 * To run a query within a React component, call `useGetLanguageVersionsForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLanguageVersionsForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLanguageVersionsForCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetLanguageVersionsForCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetLanguageVersionsForCompanyQuery, GetLanguageVersionsForCompanyQueryVariables> & ({ variables: GetLanguageVersionsForCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLanguageVersionsForCompanyQuery, GetLanguageVersionsForCompanyQueryVariables>(GetLanguageVersionsForCompanyDocument, options);
      }
export function useGetLanguageVersionsForCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLanguageVersionsForCompanyQuery, GetLanguageVersionsForCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLanguageVersionsForCompanyQuery, GetLanguageVersionsForCompanyQueryVariables>(GetLanguageVersionsForCompanyDocument, options);
        }
export function useGetLanguageVersionsForCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLanguageVersionsForCompanyQuery, GetLanguageVersionsForCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLanguageVersionsForCompanyQuery, GetLanguageVersionsForCompanyQueryVariables>(GetLanguageVersionsForCompanyDocument, options);
        }
export type GetLanguageVersionsForCompanyQueryHookResult = ReturnType<typeof useGetLanguageVersionsForCompanyQuery>;
export type GetLanguageVersionsForCompanyLazyQueryHookResult = ReturnType<typeof useGetLanguageVersionsForCompanyLazyQuery>;
export type GetLanguageVersionsForCompanySuspenseQueryHookResult = ReturnType<typeof useGetLanguageVersionsForCompanySuspenseQuery>;
export type GetLanguageVersionsForCompanyQueryResult = Apollo.QueryResult<GetLanguageVersionsForCompanyQuery, GetLanguageVersionsForCompanyQueryVariables>;
export const GetTimeZoneCompanyDocument = gql`
    query GetTimeZoneCompany($companyId: Int!) {
  user(companyId: $companyId) {
    id
    company(id: $companyId) {
      id
      timeZone {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetTimeZoneCompanyQuery__
 *
 * To run a query within a React component, call `useGetTimeZoneCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeZoneCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeZoneCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetTimeZoneCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetTimeZoneCompanyQuery, GetTimeZoneCompanyQueryVariables> & ({ variables: GetTimeZoneCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeZoneCompanyQuery, GetTimeZoneCompanyQueryVariables>(GetTimeZoneCompanyDocument, options);
      }
export function useGetTimeZoneCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeZoneCompanyQuery, GetTimeZoneCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeZoneCompanyQuery, GetTimeZoneCompanyQueryVariables>(GetTimeZoneCompanyDocument, options);
        }
export function useGetTimeZoneCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTimeZoneCompanyQuery, GetTimeZoneCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTimeZoneCompanyQuery, GetTimeZoneCompanyQueryVariables>(GetTimeZoneCompanyDocument, options);
        }
export type GetTimeZoneCompanyQueryHookResult = ReturnType<typeof useGetTimeZoneCompanyQuery>;
export type GetTimeZoneCompanyLazyQueryHookResult = ReturnType<typeof useGetTimeZoneCompanyLazyQuery>;
export type GetTimeZoneCompanySuspenseQueryHookResult = ReturnType<typeof useGetTimeZoneCompanySuspenseQuery>;
export type GetTimeZoneCompanyQueryResult = Apollo.QueryResult<GetTimeZoneCompanyQuery, GetTimeZoneCompanyQueryVariables>;
export type GetRelationsQueryVariables = Types.Exact<{
  isMessageOnly?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetRelationsQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', timezones?: Array<{ __typename?: 'TimeZoneProxy', id: number, name: string }> | null, countries?: Array<{ __typename?: 'CountryProxy', id: number, name: string, timezone?: Array<{ __typename?: 'TimeZoneProxy', id: number, name: string } | null> | null }> | null, currencies?: Array<{ __typename?: 'CurrencyProxy', id: number, code?: string | null, currency?: string | null, countries?: Array<{ __typename?: 'CountryProxy', id: number }> | null }> | null, languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string, isoCode: string, isMessage: boolean }> | null } };

export type GetCountryGeoForCompanyQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCountryGeoForCompanyQuery = { __typename?: 'Query', countryGeo?: { __typename?: 'CountryGeoProxy', country?: { __typename?: 'CountryProxy', id: number, isoCode?: string | null, phoneCode?: { __typename?: 'PhoneCodeProxy', code: string } | null, currencies?: Array<{ __typename?: 'CurrencyProxy', id: number }> | null, timezone?: Array<{ __typename?: 'TimeZoneProxy', id: number, name: string } | null> | null } | null } | null };

export type GetCountriesForCompanyQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCountriesForCompanyQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', countries?: Array<{ __typename?: 'CountryProxy', id: number, name: string, timezone?: Array<{ __typename?: 'TimeZoneProxy', id: number, name: string } | null> | null }> | null } };

export type GetGmtForUpdateCompanyQueryVariables = Types.Exact<{
  countryId: Types.Scalars['Int']['input'];
}>;


export type GetGmtForUpdateCompanyQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', timezones?: Array<{ __typename?: 'TimeZoneProxy', id: number, name: string }> | null } };

export type GetInfoCompanyQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetInfoCompanyQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, image?: string | null, website?: string | null, deleted: boolean, category?: { __typename?: 'CompanyTypeProxy', id: number, name: string, type: string } | null, country?: { __typename?: 'CountryProxy', id: number, name: string, currencies?: Array<{ __typename?: 'CurrencyProxy', code?: string | null, currency?: string | null, id: number }> | null, timezone?: Array<{ __typename?: 'TimeZoneProxy', id: number, name: string } | null> | null } | null, city?: { __typename?: 'CityProxy', id: number, name: string } | null, currency?: { __typename?: 'CurrencyProxy', id: number, code?: string | null, currency?: string | null } | null, timeZone?: { __typename?: 'TimeZoneProxy', id: number, name: string } | null, language?: { __typename?: 'LanguageProxy', name: string, id: number, isoCode: string } | null, languages?: Array<{ __typename?: 'LanguageProxy', id: number, isoCode: string, name: string }> | null, messageLanguage?: { __typename?: 'LanguageProxy', id: number, name: string, isoCode: string } | null, primaryLanguage?: { __typename?: 'LanguageProxy', id: number, name: string, isoCode: string } | null } | null } | null };

export type GetInfoCompanyForUpdateCompanyPageQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetInfoCompanyForUpdateCompanyPageQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', currentBranch?: { __typename?: 'BranchProxy', generalWorkSchedules?: Array<{ __typename?: 'BranchWorkScheduleProxy', id: number, period: string, type: { __typename?: 'BranchWorkPeriodTypeProxy', id: number, name: string, slug: string }, day: { __typename?: 'DayProxy', id: number, name?: string | null, shortName?: string | null, number: number } }> | null, kitchenWorkSchedules?: Array<{ __typename?: 'BranchWorkScheduleProxy', id: number, period: string, type: { __typename?: 'BranchWorkPeriodTypeProxy', id: number, name: string, slug: string }, day: { __typename?: 'DayProxy', id: number, name?: string | null, shortName?: string | null, number: number } }> | null } | null, company?: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, website?: string | null, image?: string | null, deleted: boolean, country?: { __typename?: 'CountryProxy', id: number, name: string, currencies?: Array<{ __typename?: 'CurrencyProxy', id: number, code?: string | null, currency?: string | null }> | null, timezone?: Array<{ __typename?: 'TimeZoneProxy', id: number, name: string } | null> | null } | null, city?: { __typename?: 'CityProxy', id: number, name: string } | null, timeZone?: { __typename?: 'TimeZoneProxy', id: number, name: string } | null, messageLanguage?: { __typename?: 'LanguageProxy', id: number, name: string } | null, currency?: { __typename?: 'CurrencyProxy', id: number, currency?: string | null, code?: string | null } | null, category?: { __typename?: 'CompanyTypeProxy', type: string } | null, languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string, isoCode: string }> | null, primaryLanguage?: { __typename?: 'LanguageProxy', id: number, name: string, isoCode: string } | null } | null } | null };

export type UpdateCompanyMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  input: Types.CompanyInput;
  branchId: Types.Scalars['Int']['input'];
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'CompanyProxy', id: number, currency?: { __typename?: 'CurrencyProxy', currencySign?: string | null } | null } };

export type CreateNewCompanyMutationVariables = Types.Exact<{
  input: Types.CompanyInput;
}>;


export type CreateNewCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'CompanyProxy', name: string, category?: { __typename?: 'CompanyTypeProxy', id: number, name: string } | null, country?: { __typename?: 'CountryProxy', id: number, name: string } | null, branches?: Array<{ __typename?: 'BranchProxy', id: number, name: string, address: string, timeZone: string, currencyCode: string, deleted: boolean, onlineRegistration: boolean, bookingQrLink: string, removedOfTariff: boolean, isAnyWorkScheduleForWorkingEmployees: boolean, isAnyActiveServices: boolean, isAnyActiveServiceEmployeeRelations: boolean, country: { __typename?: 'Country', id: string, name: string } }> | null } };

export type GetGmtQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetGmtQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', timezones?: Array<{ __typename?: 'TimeZoneProxy', id: number, name: string }> | null } };

export type GetLanguagesQueryVariables = Types.Exact<{
  isMessageOnly?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetLanguagesQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string, isoCode: string, isMessage: boolean }> | null } };

export type GetLanguagesForLanguageVersionsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetLanguagesForLanguageVersionsQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string }> | null } };

export type GetCurrenciesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrenciesQuery = { __typename?: 'Query', relations: { __typename?: 'RelationProxy', currencies?: Array<{ __typename?: 'CurrencyProxy', id: number, currency?: string | null, code?: string | null }> | null } };

export type GetCompanyQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetCompanyQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', id: number, name: string, address: string, phone: string, website?: string | null, country?: { __typename?: 'CountryProxy', id: number, name: string } | null, city?: { __typename?: 'CityProxy', id: number, name: string } | null, timeZone?: { __typename?: 'TimeZoneProxy', id: number, name: string } | null, languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string }> | null, currency?: { __typename?: 'CurrencyProxy', id: number, currency?: string | null } | null, messageLanguage?: { __typename?: 'LanguageProxy', id: number, name: string } | null } | null } | null };

export type GetBranchesIsDeletedQueryVariables = Types.Exact<{
  isDeleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetBranchesIsDeletedQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, branches?: Array<{ __typename?: 'BranchProxy', id: number, deleted: boolean, address: string, bookingQrLink: string, onlineRegistration: boolean, currencyCode: string, name: string, removedOfTariff: boolean, timeZone: string, country: { __typename?: 'Country', id: string, name: string } }> | null } | null } | null };

export type GetRoleUserQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetRoleUserQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, email?: string | null, role?: { __typename?: 'RoleProxy', id: number, name: string } | null, currentBranch?: { __typename?: 'BranchProxy', id: number } | null, company?: { __typename?: 'CompanyProxy', id: number } | null } | null };

export type GetCompanyModulesQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetCompanyModulesQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', modules?: Array<{ __typename?: 'ModuleProxy', id: number, name?: string | null, active: boolean, childModules?: Array<{ __typename?: 'ModuleProxy', id: number, name?: string | null, active: boolean } | null> | null }> | null } | null } | null };

export type GetCompanyModulesForCreateOwnerQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetCompanyModulesForCreateOwnerQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', modules?: Array<{ __typename?: 'ModuleProxy', id: number, name?: string | null, active: boolean, childModules?: Array<{ __typename?: 'ModuleProxy', id: number, name?: string | null, active: boolean } | null> | null }> | null } | null } | null };

export type GetActiveCompaniesQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetActiveCompaniesQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', companies?: Array<{ __typename?: 'CompanyProxy', id: number, name: string, loggedInUser?: { __typename?: 'EmployeeProxy', id: number, name?: string | null, surname?: string | null, role?: { __typename?: 'RoleProxy', name: string } | null, position?: { __typename?: 'EmployeePositionProxy', name: string } | null } | null }> | null, company?: { __typename?: 'CompanyProxy', id: number, name: string, isPremiumOn: boolean, deleted: boolean, image?: string | null } | null } | null };

export type GetCompanyAndRoleQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  isOnlyParents?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  branchId: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCompanyAndRoleQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, roles: Array<string>, company?: { __typename?: 'CompanyProxy', id: number, name: string, phone: string, isPremiumOn: boolean, bookingQrLink: string, address: string, deleted: boolean, image?: string | null, paidFeatures?: Array<{ __typename?: 'PaidFeatureProxy', id: number, name?: Types.Tariff | null, dateOfEnd?: string | null, price: number, dateOfLastPayment: string, isYearly: boolean }> | null, modules?: Array<{ __typename?: 'ModuleProxy', id: number, name?: string | null, active: boolean, isPaymentRequired: boolean, isPaid: boolean, isFreeAccess: boolean }> | null } | null, role?: { __typename?: 'RoleProxy', id: number, name: string, isOwner: boolean } | null, employee?: { __typename?: 'EmployeeProxy', id: number, name?: string | null, surname?: string | null, image?: string | null, userBranchRelations?: Array<{ __typename?: 'UserBranchRelationProxy', id: number, branch: { __typename?: 'BranchProxy', id: number }, role: { __typename?: 'RoleProxy', id: number, name: string } }> | null } | null } | null, role: { __typename?: 'RolePaginated', roles?: Array<{ __typename?: 'RoleProxy', id: number, name: string, isOwner: boolean, companyAccesses?: Array<{ __typename?: 'CompanyAccessProxy', action?: Types.CompanyAccess | null, id: number, role?: { __typename?: 'RoleProxy', name: string, id: number, isOwner: boolean } | null }> | null }> | null } };

export type GetCompanyAndRoleWithoutOwnerQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  isOnlyParents?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  branchId: Types.Scalars['Int']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetCompanyAndRoleWithoutOwnerQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, roles: Array<string>, company?: { __typename?: 'CompanyProxy', id: number, name: string, phone: string, isPremiumOn: boolean, bookingQrLink: string, address: string, deleted: boolean, image?: string | null, paidFeatures?: Array<{ __typename?: 'PaidFeatureProxy', id: number, name?: Types.Tariff | null, dateOfEnd?: string | null, price: number, dateOfLastPayment: string, isYearly: boolean }> | null, modules?: Array<{ __typename?: 'ModuleProxy', id: number, name?: string | null, active: boolean, isPaymentRequired: boolean, isPaid: boolean, isFreeAccess: boolean }> | null } | null, role?: { __typename?: 'RoleProxy', id: number, name: string, isOwner: boolean } | null, employee?: { __typename?: 'EmployeeProxy', id: number, name?: string | null, surname?: string | null, image?: string | null, userBranchRelations?: Array<{ __typename?: 'UserBranchRelationProxy', id: number, branch: { __typename?: 'BranchProxy', id: number }, role: { __typename?: 'RoleProxy', id: number, name: string } }> | null } | null } | null, role: { __typename?: 'RolePaginated', roles?: Array<{ __typename?: 'RoleProxy', id: number, name: string, isOwner: boolean, companyAccesses?: Array<{ __typename?: 'CompanyAccessProxy', action?: Types.CompanyAccess | null, id: number, role?: { __typename?: 'RoleProxy', name: string, id: number, isOwner: boolean } | null }> | null }> | null } };

export type GetLoginCompaniesQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type GetLoginCompaniesQuery = { __typename?: 'Query', loginCompanies?: Array<{ __typename?: 'LoginCompany', id: string, name: string, isBlocked: boolean, employee?: { __typename?: 'EmployeeLogin', id: string, name: string, surname: string, role: string } | null }> | null };

export type GetLanguageVersionsForCompanyQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetLanguageVersionsForCompanyQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', languages?: Array<{ __typename?: 'LanguageProxy', id: number, name: string }> | null, primaryLanguage?: { __typename?: 'LanguageProxy', id: number, name: string } | null } | null } | null };

export type GetTimeZoneCompanyQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetTimeZoneCompanyQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', id: number, company?: { __typename?: 'CompanyProxy', id: number, timeZone?: { __typename?: 'TimeZoneProxy', id: number, name: string } | null } | null } | null };
